<template>
  <div data-qa="club_info">
    <slot
      name="activator"
      :on="{ click: () => _isOpened = true }"
    />
    <CoreDrawer
      v-model="isOpened"
      title="Клуб ПроДокторов"
      :width="650"
    >
      <template #title-append>
        <img
          src="/static/_v1/pd/icons/ui-kit/club/club-percent.svg"
          class="ml-1"
          width="24"
          height="24"
          alt="Иконка Процент Клуба"
        >
      </template>

      <div class="d-flex flex-column gr-8 px-4 py-2">
        <div class="d-flex flex-column gr-2">
          <div class="text-h6 text--text">
            Что такое клубная цена
          </div>
          <div class="text-body-1 text--text">
            Возможность получить скидку 30% на консультацию врача, купив невозвратный опцион.
          </div>
        </div>

        <div class="d-flex flex-column gr-2">
          <div class="text-h6 text--text">
            Как получить клубную скидку
          </div>
          <ol class="club-info-list text-body-1">
            <li>При записи к врачу приобретаете опцион на сайте ПроДокторов</li>
            <li>Получаете опцион на email или в приложение МедТочка</li>
            <li>В день приёма показываете в клинике опцион и оплачиваете консультацию по цене со скидкой</li>
          </ol>
        </div>

        <div class="d-flex flex-column gr-6">
          <div class="text-h6 text--text">
            Вопросы и ответы
          </div>
          <ClubFaqList />
        </div>

        <div class="d-flex flex-column gr-2">
          <div class="text-body-2 text-secondary--text">
            © 2011 — {{ nowYear }}, ООО «МЕДРОКЕТ»
          </div>
          <div class="d-block text-body-2 text-secondary--text mt-2">
            Оплачивая, вы соглашаетесь
            с&nbsp;<a
              data-qa="club_info_offer_link"
              href="/static/_v1/pd/documents/pdf/club/Правила_использования_опционов.pdf"
              rel="noopener noreferrer"
              target="_blank"
              class="text-secondary--text link-decoration-underline"
            >офертой</a>
            и&nbsp;<a
              data-qa="club_info_club_rules_link"
              href="/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе.pdf"
              rel="noopener noreferrer"
              target="_blank"
              class="text-secondary--text link-decoration-underline"
            >правилами клуба</a>
          </div>
        </div>
      </div>
    </CoreDrawer>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import useYandexGoals from 'src/composables/useYandexGoals'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import ClubFaqList from 'src/components/common/ClubInfo/components/ClubFaqList.vue'

const props = defineProps<{
  value?: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

// eslint-disable-next-line no-underscore-dangle
const _isOpened = ref(props.value)
const isOpened = computed({
  get() {
    return Boolean(props.value || _isOpened.value)
  },
  set(value: boolean) {
    _isOpened.value = value
    emit('input', value)
  },
})

const { sendYaGoal } = useYandexGoals()
const nowYear = (process.env.IS_CLIENT && window.NOW_YEAR) || new Date().getFullYear()

watch(isOpened, value => {
  if (value) {
    sendYaGoal('club__infoModalGlobal')
  }
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.club-info-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-left: 0;
  row-gap: 16px;

  & > li {
    display: flex;
    align-items: center;
    counter-increment: list-num;
    column-gap: 16px;

    &::before {
      content: counter(list-num);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
      width: 24px;
      flex: 0 0 auto;
      color: $ui-kit-text-error;
      background-color: $ui-kit-bg-club;
      border-radius: $border-radius-circle;
    }
  }
}
</style>
